interface ShareButtonIcons {
  [key: string]: { svgPath: string };
}

export const shareButtonIcons: ShareButtonIcons = {
  copy: {
    svgPath:
      "M24,8H17.6v3.2H24a4.8,4.8,0,0,1,0,9.6H17.6V24H24a7.9,7.9,0,0,0,8-8A7.9,7.9,0,0,0,24,8ZM14.4,20.8H8a4.8,4.8,0,0,1,0-9.6h6.4V8H8a7.9,7.9,0,0,0-8,8,7.9,7.9,0,0,0,8,8h6.4ZM9.6,14.4H22.4v3.2H9.6Z",
  },
  email: {
    svgPath:
      "M32,7.9A2.6,2.6,0,0,0,31.2,6a2.9,2.9,0,0,0-1.9-.8H2.7A2.8,2.8,0,0,0,0,7.9V24.1a2.7,2.7,0,0,0,2.7,2.7H29.1a2.3,2.3,0,0,0,1.6-.6A.4.4,0,0,0,31,26c.2-.2.2-.2.2-.3a3.1,3.1,0,0,0,.6-1.6V7.9ZM2.4,9l7.4,6.1L2.4,22.6Zm13.9,8.4-3.8-3.2L4.6,7.6H27.5Zm-4.6-.7,3.8,3.2a1.1,1.1,0,0,0,.8.3c.3,0,.7-.1.8-.3l3.7-3.2L28,24.4H4.2Zm10.9-1.6L29.4,9V22.5Z",
  },
  facebook: {
    svgPath:
      "M24.2,0H20c-4.7,0-7.9,3-7.9,7.9v3.7H7.9a.6.6,0,0,0-.5.6v5.3a.5.5,0,0,0,.5.5h4.3V31.5a.5.5,0,0,0,.5.5H18a.6.6,0,0,0,.6-.5V18h5a.5.5,0,0,0,.5-.5V12.2c0-.3,0-.4-.2-.4l-.3-.2H18.8V8.4c0-1.4.3-2.1,2.3-2.1H24a.5.5,0,0,0,.5-.5V.7A.4.4,0,0,0,24.2,0Z",
  },
  linkedin: {
    svgPath:
      "M.5,10.6H7.2V32H.5ZM3.8,0A3.9,3.9,0,0,1,7.7,3.9,3.8,3.8,0,0,1,3.8,7.7,3.8,3.8,0,0,1,0,3.9H0A3.9,3.9,0,0,1,3.8,0h0m7.5,10.6h6.4v2.9h.1A6.9,6.9,0,0,1,24,10.1c6.8,0,8,4.4,8,10.2V32H25.4V21.6c0-2.5,0-5.7-3.5-5.7S18,18.7,18,21.4V32H11.3Z",
  },
  sms: {
    svgPath:
      "M9.6 14.4c.5 0 .8-.2 1.1-.5s.5-.7.5-1.1-.2-.8-.5-1.1-.7-.5-1.1-.5-.8.2-1.1.5-.5.7-.5 1.1.2.8.5 1.1.7.5 1.1.5zm6.4 0c.5 0 .8-.2 1.1-.5.3-.3.5-.7.5-1.1s-.2-.8-.5-1.1c-.3-.3-.7-.5-1.1-.5s-.8.2-1.1.5-.5.7-.5 1.1.2.8.5 1.1.7.5 1.1.5zm6.4 0c.5 0 .8-.2 1.1-.5s.5-.7.5-1.1-.2-.8-.5-1.1-.7-.5-1.1-.5-.8.2-1.1.5-.5.7-.5 1.1.2.8.5 1.1.7.5 1.1.5zM0 32V0h32v25.6H6.4L0 32zm5-9.6h23.8V3.2H3.2v21L5 22.4zm-1.8 0V3.2v19.2z",
  },
  twitter: {
    svgPath:
      "M19 13.6L30.9 0h-2.8L17.8 11.8 9.5 0H0l12.5 17.8L0 32h2.8l10.9-12.4L22.4 32h9.5M3.9 2.1h4.3L28.1 30h-4.3",
  },
  whatsapp: {
    svgPath:
      "M24.7,2.7A15.7,15.7,0,0,0,16,0,16,16,0,0,0,0,16a16.7,16.7,0,0,0,3,9.4L1.1,31.3l6.1-1.9a16.3,16.3,0,0,0,22.2-4.5A16,16,0,0,0,24.7,2.7Zm0,19.5a4.6,4.6,0,0,1-3,2.2c-.8.2-1.9.3-5.4-1.1a18.3,18.3,0,0,1-7.7-6.9,9.9,9.9,0,0,1-1.7-4.6A4.9,4.9,0,0,1,8.5,8a1.8,1.8,0,0,1,1.6-.5h.4c.5,0,.7,0,1,.8a36.6,36.6,0,0,0,1.4,3.4.6.6,0,0,1,0,.8l-.5.6c-.1.3-.4.5-.6.8a.6.6,0,0,0-.2.9,11.3,11.3,0,0,0,2.6,3.1,11.4,11.4,0,0,0,3.7,2.2A.9.9,0,0,0,19,20c.5-.5.8-1.2,1.3-1.6s.6-.5,1.1-.4l3,1.5c.5.1.8.3.8.5A5.9,5.9,0,0,1,24.7,22.2Z",
  },
};

/* ----------------------------------------------- */
export function renderShareActionIcon({ iconName }: { iconName: string }): React.JSX.Element {
  const getIconPathData = (name: string): string =>
    (shareButtonIcons[name.toLowerCase()] as { svgPath: string }).svgPath;

  const iconViewBox = "0 0 32 32";
  const iconSize = 24;

  return (
    <svg
      className="share-icon"
      height={iconSize}
      viewBox={iconViewBox}
      width={iconSize}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d={getIconPathData(iconName)} />
    </svg>
  );
}

interface ToggleShareClassProps {
  gtmEvent?: string;
}

export const toggleShareClass = ({ gtmEvent = "gtm-share" }: ToggleShareClassProps): string => {
  return `${gtmEvent} share-page`.trim();
};

/* ----------------------------------------------- */
export function shareStringEncode(inputString: string): string {
  return encodeURIComponent(inputString);
}
